<!--
 * @LastEditors: zhanglinju
-->
<template>
  <div
    class="data"
  >
    <div
      class="mobileBox"
      :class="isMargin?'haveMargin':''"
    >
      <div
        v-if="iscataloglist"
        class="ifmBox"
      >
        <div
          v-if="cataloglist.type == 0"
          class="ifmContent"
          v-html="cataloglist.htm"
        />
        <div
          v-if="cataloglist.type == 1"
          class="ifmebox"
        >
          <iframe
            :src="cataloglist.url"
            frameborder="0"
            class="ifme"
          />
        </div>
        <!-- 列表进入 视频 -->
        <div
          v-if="cataloglist.type == 2"
          class="videocontent"
        >
          <img
            :src="cataloglist.VideoImage"
            alt=""
            class="ifmebox"
          >
          <img
            class="play_icon"
            src="../../../assets/icon/icon_play.png"
            alt=""
            @click="showBox = true"
          >
        </div>
      </div>

      <div
        v-if="html && !siteStatus && !dataDtl"
        class="ifmContent"
        v-html="html"
      />
      <div
        v-if="isvideo"
        class="videoBox"
      >
        <video
          :src="videoUrl"
          :poster="poster"

          controls="controls"
        />
      </div>
      <div
        v-if="url"
        class="
          ifmBox"
      >
        <iframe
          :src="url"
          frameborder="0"
          class="ifme"
        />
      </div>
      <div
        v-if="siteStatus"
        class="nodata"
      >
        <img
          class="nodata_img"
          style="height:195px"
          src="../../../assets/image/icon_data_delete.png"
          alt=""
        >
        <span class="nodata_text">该内容已被禁用，暂无法预览</span>
      </div>
      <div
        v-if="dataDtl"
        class="nodata"
      >
        <img
          class="nodata_img"
          style="height:195px"
          src="../../../assets/image/icon_data_delete.png"
          alt=""
        >
        <span class="nodata_text2">你访问的内容已被下架，暂无法浏览</span>
      </div>
      <div
        v-if="showBox"
        class="theVideoStratum"
      >
        <div
          style="width: 100%; height: 100%; background-color: rgba(0, 0, 0)"
          class="closeTheVideo"
          @click="cls"
        />
        <div class="theVideoStratumBox">
          <video
            ref="myVideo"
            :src="videoUrl"
            autoplay="autoplay"
            controls="controls"
          />
        </div>
      </div>
    </div>
    <div class="QRcodeBox">
      <vue-qr
        :text="downloadData.url"
        :margin="0"
        color-dark="#666"
        color-light="#fff"
        :logo-scale="0.3"
        :size="200"
      />
      <span>手机扫码预览</span>
    </div>
    <lebals
      class="post"
      :showqq="showqq"
      :showdz="showdz"
    />
    <!-- 图片弹窗 -->
    <el-dialog
      :visible.sync="showImgDialog"
      width="50%"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>{{ dialogtitle }}</span>
      </div>
      <div
        class="dialogimgdiv"
      >
        <img
          :src="dialogimg"
          alt=""
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>

import api from './proxy';
// eslint-disable-next-line no-unused-vars
import vueQr from 'vue-qr';
import lebals from './lebals';
import { removeWatermark, setWaterMark } from '../../../lib/watermark';

export default {
    components: {
        lebals,
    },
    data () {
        return {
            showqq: false,
            showdz: false,
            iscataloglist: false,
            contentIndex: null,
            catalogId: null,
            cataloglist: {
                type: null,
                url: null,
                htm: null,
                videoUrl: null,
                VideoImage: null,
            },
            title: null,
            url: null,
            html: null,
            videoUrl: null,
            poster: null,
            showBox: false,
            isvideo: false,
            downloadData: {
                url: 'https://www.baidu.com/',
                icon: require('../../../assets/image/YXPLOGO.png'),
            },
            siteStatus: false,
            dataDtl: false,
            isMargin: false,
            dialogtitle: '图片预览', // 弹窗名称
            showImgDialog: false,
            dialogimg: '',
        };
    },
    created () {
        // if (!this.IsPC()) {
        //     this.$router.replace({ name: 'mobileContent', query: this.$route.query });
        // }
        let contentId = this.$route.query.contentId;
        let url = this.$route.query.url;
        this.websiteMsg = JSON.parse(sessionStorage.getItem('websiteMsg'));
        // 判断是否为url进入
        if (contentId) {
            console.log('11地址栏');
            this.getInfoCintent(contentId);
            this.getPlug();
            setTimeout(() => {
                setWaterMark(this.websiteMsg.name, '预览');
            }, 0);
            if (this.$route.query.type) {
                console.log('11');
                url = this.$router.resolve({ name: 'mobileContent', query: { contentId: contentId, type: 1 } });
                var text = window.location.origin + window.location.pathname + url.href;
            } else {
                url = this.$router.resolve({ name: 'mobileContent', query: { contentId: contentId } });
                text = window.location.origin + window.location.pathname + url.href;
            }
            this.downloadData.url = text;
            // console.log(this.downloadData.url);
        } else if (url !== null && url !== undefined) {
            // 判断是否为iframe显示
            console.log('预览进入');
            this.url = url;
        } else {
            // 是否为列表进入
            console.log('列表进入');
            this.contentIndex = this.$route.query.contentIndex;
            this.catalogId = this.$route.query.catalogId;
            this.catalogDetail(this.catalogId);
            this.getPlug();
            setTimeout(() => {
                setWaterMark(this.websiteMsg.name, '预览');
            }, 0);
        }
    },
    mounted () {
    },

    destroyed () {
        removeWatermark();
    },
    methods: {
        IsPC () {
            var userAgentInfo = navigator.userAgent;
            var Agents = ['Android', 'iPhone',
                'SymbianOS', 'Windows Phone',
                'iPad', 'iPod'];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        },
        catalogDetail (id) {
            let params = {
                siteId: sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
                catalogId: id,
            };
            api.catalogDetail(params).then(res => {
                if (res.errcode === 0) {
                    let cataloglist = res.data.list;
                    cataloglist.sort(function (a, b) {
                        return a.rank - b.rank;
                    });
                    cataloglist = cataloglist[this.contentIndex];
                    let contentId = cataloglist.contentId;
                    let url = this.$router.resolve({ name: 'mobileContent', query: { contentId } });
                    let text = window.location.origin + window.location.pathname + url.href;
                    this.downloadData.url = text;

                    document.title = cataloglist.title;
                    if (cataloglist.contentType === 0) {
                        this.cataloglist.type = 0;
                        this.cataloglist.htm = cataloglist.contentText;
                    } else if (cataloglist.contentType === 1) {
                        this.cataloglist.type = 1;
                        this.cataloglist.url = cataloglist.contentLink;
                    } else if (cataloglist.contentType === 2) {
                        this.cataloglist.type = 2;
                        this.videoUrl = cataloglist.contentVideo;
                        this.cataloglist.VideoImage = cataloglist.contentVideoImage;
                    }
                    this.iscataloglist = true;
                }
            });
        },
        getInfoCintent (id) {
            if (this.$route.query.type) {
                var params = {
                    contentId: id,
                    type: 1,
                };
            } else {
                params = {
                    contentId: id,
                };
            }
            api.getInfoCintent(params).then(res => {
                console.log(res);
                if (res.errcode === 0) {
                    this.urlList = res.data;
                    document.title = this.urlList.title;
                    let type = this.urlList.contentType;
                    console.log(this.urlList.marginStatus);
                    this.urlList.marginStatus === 0 ? this.isMargin = false : this.isMargin = true;
                    console.log();
                    if (res.data.siteStatus === 1) {
                        if (type === 0) {
                            this.html = this.urlList.contentText;
                        } else if (type === 1) {
                            this.url = this.urlList.contentLink;
                        } else if (type === 2) {
                            this.videoUrl = this.urlList.contentVideo;
                            this.poster = this.urlList.contentVideoImage;
                            this.isvideo = true;
                        }
                    } else {
                        this.siteStatus = true;
                    }
                } else if (res.errcode === 1001) {
                    this.dataDtl = true;
                }
            });
        },
        // 获取插件是否显示
        getPlug () {
            const params = {
                siteId: sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getPageManagePlugList(params).then((res) => {
                if (res.errcode === 0) {
                    let tableData = res.data.list;
                    this.showqq = tableData[0].useType.includes('1');
                    this.showdz = tableData[1].useType.includes('1');
                }
            });
        },
        cls () {
            this.showBox = false;
        },
        getimgsrc: function (e) {
            if (e.target.tagName.toUpperCase() === 'IMG') {
                this.showImgDialog = true;
                this.dialogimg = e.target.src;
                console.log(e.target.src);
            }
        },
    },
};
</script>
<style lang="scss">
.data table{
  border: 1px solid #ccc;

}
.data table tbody th{
    border-bottom: 2px solid #ccc;
    text-align: center;
    background-color: #f1f1f1;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
    min-height: 30px;
}
.data table tbody td{
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
    min-height: 30px;
}
.ifmContent{
  background: white;
  p{
    img{
          height: auto;
          vertical-align: bottom
    }
  }
  video{
    width: 100% !important;
    margin:0 !important;
  }
  a{
      text-decoration:underline;
      color:#428bca;
  }
}
</style>
<style lang="scss" scoped>
.data {
  display: flex;
  // align-items: center;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  background: #f9f9fa;
  // background:#eee ;
  .mobileBox {
    background: white;
    //background-image:url('../../../assets/image/phone.png') ;
    background-size: 100% 100%;
    width: 500px;
    height: 100%;
    border-radius: 5px;
    //padding: 65px 20px 50px 20px;
    box-shadow: 0px 0px 10px rgba(187,187,187,0.5);
    .titleBox{
      background: #ededed;
      padding: 5px;
      display: flex;
      align-items: center;
      .title{
        margin-left: 40px;
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
  .ifmBox {
    width: 100%;
    height: 95%;
  }
  .ifmebox {
    width: 100%;
    height: 100%;
  }
  .ifme {
    width: 100%;
    height: 100%;
  }
  .videoBox {
    width: 100%;
    height: 28vh;
    margin-top: 40%;
    video {
      width: 100%;
    }
  }
}
.dialogimgdiv{
  width: 100%;
  height: 100%;
  img{
    width: 100%;
    height: 100%;
  }
}
.ifmContent{
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  // text-align: center;
  // border: 1px solid #e9eaec;
  // padding: 5px;
  p{
    video{
      margin: 0 auto;
    }
  }
}
.ifmContent::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 0px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 0px;
  }

.play_icon {
  width: 60px;
  height: 60px;
  position: relative;
  top: -140px;
  left: 45%;
}
.theVideoStratum {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  width: 345px;
  height: 595px;
  position: absolute;
  top: 145px;
}
.videocontent{
 margin:  auto 0;
 width: 100%;
 height: 170px;
}
.theVideoStratumBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  width: 100% !important;
  video{
    width: 100%;
  }
}
.post {
    position: absolute;
    right: 45%;
    bottom: 1%;
  }
.QRcodeBox{
    padding: 10px;
    height: 250px;
    background: #ffffff;
    border-radius: 10px;
    // margin-top: 200px;
    // border: 1px solid black;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    margin-left: 40px;
    span{
      margin-top: 10px;
    }
}
.nodata{
  width: 300px;
  height: 230px;
  position: relative;
  .nodata_img{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 10%;
    top: 50%;
  }
  .nodata_text{
    position: absolute;
    top: 150%;
    left: 26%;
  }
  .nodata_text2{
    position: absolute;
    top: 150%;
    left: 24%;
  }
}
.haveMargin{
  padding: 0 10px;
}
</style>
